import { createSlice } from "@reduxjs/toolkit";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/es/storage";
import { name } from "../config/name.js";
const initialState = {
  activeGroups: []
};
const slice = createSlice({
  name,
  initialState,
  reducers: {
    setActiveGroups: (state, action) => ({
      ...state,
      activeGroups: action.payload
    })
  }
});
const reducer = persistReducer(
  {
    key: slice.reducerPath,
    version: 1,
    storage,
    whitelist: ["activeGroups"]
  },
  slice.reducer
);
const { actions, reducerPath } = slice;
export {
  actions,
  reducer,
  reducerPath,
  slice
};
